module.exports = __webpack_public_path__ + "media/images/common/box_bg_top-34cd3b6a995a977eab030f6bdf6e9fcd.gif";